export default __webpack_public_path__ + "assets/555918.svg";